import React from 'react';
import { View, StyleSheet } from 'react-native';
import { REDESIGN_SPACING } from '@/constants/residents/homeConstants';
import { GlassCard } from '@/components/residents/redesign';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCircle,
  SkeletonTextBlock,
} from '@/components/common/skeleton';

export const ThreadDetailSkeleton: React.FC = React.memo(() => (
  <SkeletonGroup style={styles.outerContainer}>
    <GlassCard borderRadius={16} padding={20}>
      {/* Title placeholder — two rounded rectangles */}
      <View style={styles.titleSection}>
        <SkeletonBone width="100%" height={16} borderRadius={8} />
        <SkeletonBone width="75%" height={16} borderRadius={8} />
      </View>

      {/* Author strip — circle + name + timestamp */}
      <View style={styles.authorStrip}>
        <SkeletonCircle size={40} />
        <View style={styles.authorTextGroup}>
          <SkeletonBone width={120} height={14} />
          <SkeletonBone width={80} height={12} />
        </View>
      </View>

      {/* Body text — 4 lines */}
      <View style={styles.bodySection}>
        <SkeletonTextBlock lines={4} lastLineWidth="60%" lineHeight={14} gap={6} />
      </View>

      {/* Action bar — two button placeholders */}
      <View style={styles.actionBar}>
        <SkeletonBone width={80} height={32} borderRadius={8} />
        <SkeletonBone width={80} height={32} borderRadius={8} />
      </View>
    </GlassCard>
  </SkeletonGroup>
));

ThreadDetailSkeleton.displayName = 'ThreadDetailSkeleton';

const styles = StyleSheet.create({
  outerContainer: {
    paddingHorizontal: REDESIGN_SPACING.horizontalPadding,
    paddingTop: 20,
  },
  titleSection: {
    gap: 8,
    marginBottom: 16,
  },
  authorStrip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    marginBottom: 16,
  },
  authorTextGroup: {
    gap: 6,
  },
  bodySection: {
    marginBottom: 20,
  },
  actionBar: {
    flexDirection: 'row',
    gap: 10,
  },
});
